import { Box, Button, Group, Stack } from "@mantine/core";
import Cropper from "react-easy-crop";
import { useTranslation } from "react-i18next";

import { Modal } from "../../Modal";
import { ZoomControl } from "./ZoomControl";

interface Props {
  opened: boolean;
  handleCancel: () => void;
  onCropComplete: (croppedArea: any, croppedAreaPixels: any) => void;
  crop: { x: number; y: number };
  setCrop: (crop: { x: number; y: number }) => void;
  zoom: number;
  setZoom: (zoom: number) => void;
  imageSrc: string | null;
  upload: () => void;
  updateAvatarMutation: {
    isPending: boolean;
  };
}

export const ModalEditUserAvatar: React.FC<Props> = ({
  opened,
  handleCancel,
  onCropComplete,
  crop,
  setCrop,
  zoom,
  setZoom,
  imageSrc,
  upload,
  updateAvatarMutation,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={handleCancel}
      title={t("components.userAvatar.edit_image")}
      size="md"
      centered
    >
      <Stack gap="md">
        <Box bg=".primary-10" h="18.75em" pos="relative">
          {/* Cropper: this allows the user to crop their uploaded image instead of using the full image */}
          {imageSrc && (
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={1}
              cropShape="round"
              showGrid={false}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          )}
        </Box>

        <ZoomControl zoom={zoom} setZoom={setZoom} />

        {/* Actions */}
        <Group justify="flex-end" gap="sm">
          <Button variant="outline" onClick={handleCancel} aria-label={t("common.cancel")}>
            {t("common.cancel")}
          </Button>
          <Button
            onClick={upload}
            loading={updateAvatarMutation.isPending}
            aria-label={t("common.confirm")}
          >
            {t("common.confirm")}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
